// ✅ Remove connected-react-router, add rootReducer export
import { combineReducers } from 'redux';

import {
  auth,
  businessCategories,
  businessInfo,
  businessReferralProgram,
  couponBuilder,
  coupons,
  customerCoupons,
  dashboards,
  language,
  locations,
  memberships,
  passwords,
  pointsBalance,
  referralCodes,
  signup,
  taxRates,
  theme,
  usedCoupons,
  couponImages,
  sendNotification,
  followers,
  pointsRequests,
  admin,
  affiliateBusiness,
  rakuten,
  awin,
  payment,
  couponWizard,
  aiContent,
  cj,
  stats,
  impact,
  businesses,
  customerProfile,
  cities,
  referrals,
  customerPreferences,
  couponRangeList,
  products,
  email,
  latestRedemptions
} from './modules';

export const reducerMap = {
  auth: auth.reducer,
  signup: signup.reducer,
  referralCodes: referralCodes.reducer,
  locations: locations.reducer,
  businessCategories: businessCategories.reducer,
  businessReferralProgram: businessReferralProgram.reducer,
  couponBuilder: couponBuilder.reducer,
  businessInfo: businessInfo.reducer,
  theme: theme.reducer,
  language: language.reducer,
  passwords: passwords.reducer,
  pointsBalance: pointsBalance.reducer,
  dashboards: dashboards.reducer,
  coupons: coupons.reducer,
  customerCoupons: customerCoupons.reducer,
  memberships: memberships.reducer,
  usedCoupons: usedCoupons.reducer,
  taxRates: taxRates.reducer,
  couponImages: couponImages.reducer,
  sendNotification: sendNotification.reducer,
  followers: followers.reducer,
  pointsRequests: pointsRequests.reducer,
  admin: admin.reducer,
  affiliateBusiness: affiliateBusiness.reducer,
  rakuten: rakuten.reducer,
  awin: awin.reducer,
  payment: payment.reducer,
  couponWizard: couponWizard.reducer,
  aiContent: aiContent.reducer,
  cj: cj.reducer,
  stats: stats.reducer,
  impact: impact.reducer,
  businesses: businesses.reducer,
  customerProfile: customerProfile.reducer,
  cities: cities.reducer,
  referrals: referrals.reducer,
  customerPreferences: customerPreferences.reducer,
  couponRangeList: couponRangeList.reducer,
  products: products.reducer,
  email: email.reducer,
  latestRedemptions: latestRedemptions.reducer,
};

export default combineReducers(reducerMap);
